import React from "react";
import NewsletterTwentySeven from "../component/NewsletterTwentySeven";

function NewsletterTwentySevenContainer() {
  return <NewsletterTwentySeven />;
}

export default NewsletterTwentySevenContainer;
